import { Validators } from '@angular/forms';
import { BaseForm } from '../../core/forms/base.form';

export class ActivityDeclarationMultiForm extends BaseForm {

    constructor() {
        super();
        this.validationForm = this.formBuilder.group({
            range: [null, Validators.required],
            projectId: [null, Validators.required],
            lotId: [null, Validators.required],
            duration: [null, Validators.required],
            description: [null]
        });
    }

    public toRequestForm() {
        return {
            start: this.validationForm.get('range').value[0],
            end: this.validationForm.get('range').value[1],
            project_id: this.validationForm.get('projectId').value,
            lot_id: this.validationForm.get('lotId').value,
            duration: this.validationForm.get('duration').value,
            description: this.validationForm.get('description').value,
        };
    }
}
